export var ANIMATE_HEIGHT = 'animate-height';
//# sourceMappingURL=animations.js.map